<template>
  <pw-layout>
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-4">
        <b-card
            :header="$t('login.headline')"
            header-tag="h4"
            bg-variant="light"
            class="mb-3"
        >
          <div id="firebaseui-auth-container"></div>
        </b-card>
      </div>
      <div class="col-sm-4">
      </div>
    </div>
  </pw-layout>
</template>
<script>
import { auth } from "firebase";
import { auth as uiAuth } from "firebaseui";
import PwLayout from "@/components/PwLayout.vue";

export default {
  components: {
    PwLayout
  },
  mounted() {
    const ui = new uiAuth.AuthUI(auth());
    const uiConfig = {
      signInFlow: 'popup',
      signInSuccessUrl: "/home",
      signInOptions: [auth.GoogleAuthProvider.PROVIDER_ID]
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  }
}
</script>

<style lang="scss">
@import "firebaseui/dist/firebaseui";
</style>
